import { IS_PRODUCTION } from '../config/envs';
import { objectUtils } from '../utils';
import { decryptData } from '../utils/encryption';
import { createInstanceNoToken } from './config';

const BASE_URL = 'page-configs';

export const getPageConfig = async (companyId, pageName) => {
  const axios = createInstanceNoToken();
  const { data } = await axios.get(`${BASE_URL}/company/${companyId}/name/${pageName}`);
  if (objectUtils.isValidObject(data)) {
    const { payload } = data;
    if (!IS_PRODUCTION) return payload;
    const uncrpytedPayload = decryptData(payload);
    return JSON.parse(uncrpytedPayload);
  }
  throw new Error('No page config found');
};

export const getLastPageConfigByEntityAndName = async (entityId, companyId, name) => {
  const axios = createInstanceNoToken();
  const { data } = await axios.get(`${BASE_URL}/entity/${entityId}/company/${companyId}/name/${name}`);

  if (objectUtils.isValidObject(data)) {
    const { payload } = data;
    if (!IS_PRODUCTION) return payload;
    const uncrpytedPayload = decryptData(payload);
    return JSON.parse(uncrpytedPayload);
  }
  throw new Error('No page config found');
};
